<template>
    <div class="col-7 col-md-10 px-0 px-md-1 search-bar-columns-getter">
        <b-input-group
            size="lg"
            class="custom-input-group"
        >
            {{ /* Search icon */ }}
            <b-input-group-prepend class="custom-search-prepend" is-text>
                <b-icon icon="search" scale="0.8"></b-icon>
            </b-input-group-prepend>

            {{ /* Administrative region */ }}
            <p class="text-administrative-region d-none d-md-block" v-if="text && isSuggestionSelected">
                <span class="text-hidden search-form-control text-sizer-small">{{text}}</span>
                <span class="text-muted small ml-4">{{administrativeRegion}}</span>
            </p>

            {{ /* Transparent input */ }}
            <b-form-input
                v-model="text"
                :placeholder="$t('dashboard.searchPlaceholder')"
                class="search-form-control px-0 px-md-1 text-sizer-small"
                @input="handleSuggestionsBarFocus"
            >
            </b-form-input>
        </b-input-group>
        <div
            class="search-bar-result-warapper"
            :class="isSuggestionsBarOpen && 'active'"
        >
            <div>
                <p class="search-bar-result-item title">{{$t("dashboard.results")}}</p>
            </div>
            <ul class="search-bar-result-container">
                <li
                    class="search-bar-result-item"
                    v-if="filteredData.length === 0"
                >
                    {{$t("dashboard.no-results-found")}}
                </li>
                <li
                    v-for="(data, index) in filteredData"
                    class="search-bar-result-item"
                    :data-index="index"
                    :key="data[0] + data[6] + index"
                    ref="dams"
                    tabindex="0"
                    @click="wrapperHandler"
                    @focus="updateFocusedElementId(index)"
                >
                    {{isTypeLngBg ? data[6] : data[0]}}
                    {{'&nbsp;'}}
                    <span class="text-muted small ml-3">{{data[7]['administrative_region']}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    // vuex
    import {mapGetters, mapActions} from "vuex";
    import {
        SET_MAP_COORDINATES,
        SET_MAP_ZOOM,
        SET_ACTIVE_STATION,
        SET_INFO_WINDOW_CLOSE,
        CLEAR_MAP_DATA_FILTER,
        SET_PS_DATA_FILTER
    } from '../../store/actions/dashboard';

    export default {
        name: "Searchbar.vue",
        data() {
            return {
                text: '',
                administrativeRegion: '',
                isInputActive: false,
                isSuggestionsBarOpen: false,
                isSuggestionSelected: false,
                data: [],
                focussedElId: null,
                isTypeLngBg: false
            }
        },
        computed: {
            ...mapGetters(["getPsData", "getPsNameFilter"]),
            filteredData () {
                const dams = this.getPsData['PS_stations'];
                const input = this.text.toLowerCase();

                if (dams) {
                    return dams.filter((item) => {
                        const enDamTitle = item[0];
                        const bgDamTitle = item[6];

                        if (enDamTitle.toLowerCase().includes(input)) {
                            this.isTypeLngBg = false;
                            return item;
                        }

                        if (bgDamTitle.toLowerCase().includes(input)) {
                            this.isTypeLngBg = true;
                            return item;
                        }
                    });
                }
                return [];
            }
        },
        methods: {
            ...mapActions([
                SET_MAP_COORDINATES,
                SET_MAP_ZOOM,
                SET_ACTIVE_STATION,
                SET_INFO_WINDOW_CLOSE,
                CLEAR_MAP_DATA_FILTER,
                SET_PS_DATA_FILTER
            ]),
            handleSuggestionsModalClose() {
                // Closing suggestions modal
                this.isSuggestionsBarOpen = false;
                // Remove input active statuss
                this.isInputActive = false;
                // Clear the foucused el id
                this.focussedElId = null;
                this.setGlobalSubstringFilter();
            },
            handleSuggestionsModalOpen() {
                // Opens suggestions modal
                this.isSuggestionsBarOpen = true;
                // Set input active statuss
                this.isInputActive = true;
            },
            handleSuggestionsBarFocus() {
                // Close map info window on start typing
                this.handleMapInfoWindowState();
                if (this.text.length > 0) {
                    this.handleSuggestionsModalOpen();
                }
                // Clears the administrative area
                this.administrativeRegion = "";
                this.isSuggestionSelected = false;
            },
            /**
             * Handles close suggestions modal when click outside of it
             */
            handleSuggestionsModalOutsideClick(e) {
                if (this.isInputActive &&
                    !e.target.classList.contains('search-bar-result-warapper'
                )) {
                    this.handleSuggestionsModalClose();
                }
            },
            /**
             * Handles the keyboard interaction during search
             */
            handleKeyBoardKeys(event) {
                switch (event.keyCode) {
                    case 13:
                        // Handle Enter key
                        // clear elId
                        this.focussedElId = null;
                        this.setMapCoordinates(event);
                        this.setGlobalSubstringFilter();
                        break;
                    case 27:
                        // Handle ESC key
                        this.handleSuggestionsModalClose();
                        break;
                    case 38:
                        // Handle Arrow up key
                        if (this.focussedElId === null) {
                            this.focussedElId = 0;
                        } else if (this.focussedElId > 0) {
                            this.focussedElId--;
                        }
                        this.$refs.dams[this.focussedElId].focus();
                        break;
                    case 40:
                        // Handle Arrow down key
                        if (this.focussedElId === null) {
                            this.focussedElId = 0;
                        } else if (this.focussedElId < this.filteredData.length - 1) {
                            this.focussedElId++;
                        }
                        this.$refs.dams[this.focussedElId].focus();
                        break;
                }
            },
            /**
             * Handles the update of the focussedElId on Tab navigation
             */
            updateFocusedElementId(index) {
                this.focussedElId = index;
            },
            /**
             * Function for trigger set map coordinates and zoom level on map
             */
            setMapCoordinates(e) {
                const data = this.filteredData;
                const index = Number(e.target.dataset.index);

                // a dam is chosen by index, so if any, map and zoom
                if (index || !isNaN(index)) {
                    const [,,lat, lng] = data[index];
                    // Fills the input text with selected result
                    this.text = this.isTypeLngBg ? data[index][6] : data[index][0];
                    this.administrativeRegion = data[index][7]['administrative_region'];
                    // Sets the coordinates and zoom level
                    this.SET_MAP_COORDINATES({lat, lng});
                    this.SET_MAP_ZOOM(11);
                    this.SET_ACTIVE_STATION(data[index]);
                    this.isSuggestionSelected = true;
                }

                // Clears the legend filter
                this.CLEAR_MAP_DATA_FILTER();
                // Close the modal
                this.handleSuggestionsModalClose();
            },
            handleMapInfoWindowState() {
                this.SET_ACTIVE_STATION([]);
                this.SET_INFO_WINDOW_CLOSE();
            },
            /**
             * set the global filter
             * called on suggestions close
             * by outer click, enter and click on dam
             */
            setGlobalSubstringFilter() {
                this.SET_PS_DATA_FILTER(this.text);
            },
            /**
             * Simple wrapper to call both functions
             * on click on the suggestion.
             * @param event
             */
            wrapperHandler(event) {
                this.setMapCoordinates(event);
                this.setGlobalSubstringFilter();
            }
        },

        mounted() {
            document.body.addEventListener('keyup', this.handleKeyBoardKeys);
            document.body.addEventListener('click', this.handleSuggestionsModalOutsideClick);
        },
        destroyed() {
            document.body.removeEventListener('keyup', this.handleKeyBoardKeys);
            document.body.removeEventListener('click', this.handleSuggestionsModalOutsideClick);
            // clear store
            this.text = '';
            this.setGlobalSubstringFilter();
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/variables";
    /****************************************************************************
     SEARCH
    ****************************************************************************/

    .custom-input-group {
        position: relative;
        margin-top: 5px;
    }

    .custom-search-prepend {
        .input-group-text {
            background-color: $whiteColor;
            border-radius: 0;
            border: none
        }
    }

    .search-form-control {
        border: none;
        box-shadow: unset;
        background: transparent;
    }

    /* Search result items displayed under the search bar */
    .search-bar-result {
        &-warapper {
            display: none;
            bottom: -3px;
            padding: 5px 0 20px;
            position: relative;
            z-index: 2;
            width: 100vw;

            &.active {
                display: block;
                background-color: $whiteColor;
                border-radius: 0px 0px 10px 10px;
                box-shadow: 0px 5px 10px $search-bar-box-shadow;
            }
        }

        &-container {
           list-style: none;
           padding: 0;
           margin: 0;
           max-height: 70vh;
           overflow: auto;
        }

        &-item {
            font-size: 14px;
            color: $darkColor;
            line-height: 20px;
            padding: 5px 20px;

            &:hover:not(.title) {
                background-color: $search-bar-item-hover-color;
                cursor: pointer;
            }

            &.title {
                font-size: 12px;
                color: $search-bar-title-text-color;
                border-bottom: 1px solid $search-bar-title-text-color;
            }
            &:focus {
                outline: none;
                background-color: $search-bar-item-hover-color;
            }
        }
    }

    .text-administrative-region {
        position: absolute;
        top: 50%;
        left: 53px;
        transform: translateY(-50%);

        .text-hidden {
            visibility: hidden;
            font-size: $font-size-lg;
        }
    }

    @media (min-width: 768px) {
        .search-bar-result-warapper {
            bottom: -10px;
            right: -5px;
            width: 100%;
        }
    }

    @media screen and (max-width: 762px) {
        /*.search-bar-columns-getter {*/
        /*    padding-right: 0;*/
        /*}*/
        .bi-search {
            margin-right: 0.15rem;
            font-size: 100% !important;
        }
        .search-form-control.text-sizer-small {
            font-size: 1rem;
            min-height: 55px;
        }
    }

    /****************************************************************************
      /SEARCH
     ****************************************************************************/
</style>